import axios from "axios";
import type { AxiosInstance } from "axios";
import { ElMessage } from "element-plus";
import router from "@/router/index";
import { getToken, clearToken } from "./common";
import { addPending, removePending, authMsg } from "./request";

// Create a new axios instance specifically for analytics
const analyticsRequest: AxiosInstance = axios.create({
	baseURL: import.meta.env.DEV ? '' : import.meta.env.VITE_ANALYTICS_BASE_URL
});


// Set up interceptors similar to the main request.ts file
analyticsRequest.interceptors.request.use(
	function (config) {
		removePending(config);
		addPending(config);

		// Add your request interceptor logic here
		config.headers["app-code"] = "WEB";
		const token = getToken();
		if (token) {
			config.headers["access-token"] = token;
		}
		return config;
	},
	function (error) {
		return Promise.reject(error);
	},
);

analyticsRequest.interceptors.response.use(
	function (response) {
		removePending(response.config);
		if (response.status === 200) {
			let data = null;

			if (response.config.responseType === "blob") {
				data = response;
			} else {
				data = response.data;
			}
			if (response.data.status && response.data.status !== 200) {
				ElMessage.closeAll();
				ElMessage({
					type: "error",
					message: response.data.message,
				});
				if (response.data.status === 401) {
					clearToken();
					router.push({
						path: "/login",
					});
					ElMessage.closeAll();
					ElMessage({
						type: "error",
						message: response.data.message,
					});
				}
				return Promise.reject(data);
			}
			return data;
		} else {
			ElMessage.closeAll();
			ElMessage({
				type: "error",
				message: response.data?.message || authMsg("serverUnavailable"),
			});
			if (response.status === 401) {
				clearToken();
				router.push({
					path: "/login",
				});
			}
			return Promise.reject(response);
		}
	},
	function (error) {
		removePending(error.config);
		let status = 0;
		if (error.response) {
			status = error.response.status;
		} else {
			return Promise.reject(error);
		}

		if (status === 401) {
			router.push({
				path: "/login",
			});
		}
		ElMessage.closeAll();
		try {
			if (error.response) {
				ElMessage({
					type: "error",
					message: error?.response?.data?.message || authMsg("serverUnavailable"),
				});
			}
		} catch {
			// Empty catch block
		}
		return Promise.reject(error);
	}
);

export default analyticsRequest;